
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/uk/sitemap",
      function () {
        return require("private-next-pages/uk/sitemap.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/uk/sitemap"])
      });
    }
  